// extracted by mini-css-extract-plugin
module.exports = {"trigger":"jut__QuickViewHeaderActions__trigger"};